module.exports = __webpack_public_path__ + "static/media/3DPPA16.ccfcb1b4.jpg";